import React from "react";
import { scrollToClass } from "../utils/scroll";


const OfferSection = ({imagesData,tittle}) => {
    

    const handleClick = () => {
        if (tittle === 'info-section') {
            scrollToClass(`calendary-section`,10)
        }
    }



    return (
    <section className={tittle}>
        {imagesData.map((img,i) => (
            <div onClick={() => {handleClick()}} key={i} className="offer-panel">
            <div>
                <img width={img.width} height={img.height} src={img.imageSrc} alt={img.altText}></img>
            </div>
            <h3>{img.text}</h3>
            </div>

        ))}

    </section>
    )
}


export default OfferSection;
